import React from 'react';
import { AppBar, Toolbar, Container, Card, CardContent, CardMedia, Typography, Button, List, ListItem, Grid, Box, TextField, styled } from '@mui/material';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import ContactUsForm from '../../components/contactus/ContactUsForm';


const PageContainer = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(8),
  marginBottom: theme.spacing(8),
}));

const SectionCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(5),
  boxShadow: theme.shadows[3],
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const ContactForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

function ClientAcquisitionPage() {
  return (
    <>
     <LandingPageNav/>
      {/* Promotion Section */}
      <PageContainer maxWidth="lg">
        <Typography variant="h4" gutterBottom>
          Elevate Your Client Acquisition
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          Discover how our cutting-edge tools can simplify your client acquisition process, making it easier and more efficient than ever to grow your business.
        </Typography>
      </PageContainer>

      {/* Product Showcase Section */}
      <PageContainer maxWidth="lg">
        <SectionCard>
          <Grid container>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <CardMedia
                  component="img"
                  sx={{ width: 650, height: 'auto', pl: 2 }}
                  image="/assets/toolscreenshot.JPG"
                  alt="Product Image"
                />
                <CardContent sx={{ flex: '1 0 auto' }}>
                  <Typography component="div" variant="h5">
                    INNOVATIVE PRODUCT SOLUTIONS
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary" component="div">
                    BRINGING YOUR IDEAS TO LIFE
                  </Typography>
                </CardContent>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', padding: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <List>
                      <ListItem>• Advanced Technology Integration</ListItem>
                      <ListItem>• Customizable Solutions</ListItem>
                      <ListItem>• Eco-friendly Materials</ListItem>
                    </List>
                  </Grid>
                  <Grid item xs={6}>
                    <List>
                      <ListItem>• Industry-Leading Warranties</ListItem>
                      <ListItem>• 24/7 Customer Support</ListItem>
                      <ListItem>• Global Shipping Available</ListItem>
                    </List>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            
          </Grid>
        </SectionCard>

        {/* Contact Us Section */}
        <SectionCard>
        <ContactUsForm />
        </SectionCard>
      </PageContainer>
    </>
  );
}

export default ClientAcquisitionPage;

